import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import { getValorDeMercadoColor } from '@/helpers/mui-helper';
import { toPriceInEuros } from '@/helpers/prices-helper';
import { Box, Typography, useTheme } from '@mui/material';

const JugadoresMercadoResumen = ({ player, isDrawer }) => {
    const theme = useTheme();
    const marketValues = player?.marketValues ?? [];

    // Función para obtener la diferencia en valor de mercado
    const getChange = (days) => {
        const valorActual = marketValues[0]?.marketValue ?? 0;
        const valorAntiguo = marketValues[days]?.marketValue ?? 0;
        return valorActual - valorAntiguo;
    };

    return (
        <CustomSectionWrapper title=" Subida y bajada de los últimos valores de mercados" color="accent2">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                <Typography fontSize={14}>Valor actual:</Typography>
                <Typography fontSize={14}>{toPriceInEuros(marketValues[0]?.marketValue ?? 0)}</Typography>
            </Box>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: isDrawer
                        ? 'repeat(4, 1fr)'
                        : {
                              xs: 'repeat(auto-fill, minmax(80px, 1fr))', // En móvil: distribución automática
                              md: 'repeat(7, 1fr)', // En desktop: 7 columnas para ocupar 100%
                          },
                    gap: '4px',
                    width: '100%',
                }}
            >
                {[1, 2, 3, 5, 10, 14, 20, 29].map((days) => (
                    <Box
                        key={days}
                        sx={{
                            padding: '6px 5px',
                            border: '1px solid',
                            borderColor: 'border.main',
                            borderRadius: '4px',
                            textAlign: 'center',
                            width: '100%',
                        }}
                        display={{ xs: 'block', md: days === 20 && !isDrawer ? 'none' : 'block' }}
                    >
                        <Typography variant="h4" fontSize={14}>
                            Último{days === 1 ? '' : 's'} {days === 1 ? '' : days}
                        </Typography>
                        <Typography
                            sx={{
                                color: getValorDeMercadoColor(getChange(days), theme),
                            }}
                            fontSize={{ xs: 12, md: 14 }}
                        >
                            {getChange(days) !== '-'
                                ? `${getChange(days) > 0 ? '+' : ''}${toPriceInEuros(getChange(days))}`
                                : '-'}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </CustomSectionWrapper>
    );
};

export default JugadoresMercadoResumen;
